import { Flex, Link, Typography, emailRegex } from '@iheartjane/reefer';
import { Form } from '@iheartjane/reefer-hook-form';

import { ContinueWith } from '@jane/shared-ecomm/components';

interface SignInScreenProps {
  error: string | null;
  onAppleClick(): void;
  onForgotPassword(): void;
  onGoogleClick(): void;
  onSubmit(user: SignInFormData): void;
  storeName: string;
}

type SignInFormData = {
  email: string;
  password: string;
};

export const SignInScreen = ({
  error,
  onAppleClick,
  onGoogleClick,
  onForgotPassword,
  onSubmit,
  storeName,
}: SignInScreenProps) => {
  return (
    <Flex flexDirection="column" p={24} alignItems="center" width="100%">
      <Form
        name="sign-in"
        onSubmit={onSubmit}
        width="100%"
        data-testid="sign-in-form"
      >
        <Typography variant="h2-semibold" textAlign="center" mb={8}>
          Sign in to Jane
        </Typography>
        <Typography variant="body-semibold" textAlign="center" mb={16}>
          Kiosk at {storeName}
        </Typography>
        <ContinueWith
          buttonSize="small"
          onAppleClick={onAppleClick}
          onGoogleClick={onGoogleClick}
          showAppleLogin
          showGoogleLogin
        />
        <Form.TextField
          type="email"
          autocomplete="off"
          label={
            <Typography variant="body-semibold" mt={16} mb={-8}>
              Email address
            </Typography>
          }
          name="email"
          required
          errorMessage="Please enter a valid email address."
          errorOnBlur
          pattern={emailRegex}
          disableMobileInputStyling
          mb={16}
          borderRadius="xs"
        />
        <Form.TextField
          type="password"
          autocomplete="off"
          label={
            <Typography variant="body-semibold" mb={-8}>
              Password
            </Typography>
          }
          name="password"
          required
          pattern={/.*/}
          disableMobileInputStyling
          borderRadius="xs"
        />
        {error && (
          <Typography color="error" mt={12}>
            {typeof error === 'string'
              ? error
              : 'There was an error logging in.'}
          </Typography>
        )}
        <Form.SubmitButton
          full
          size="small"
          variant="primary"
          label="Sign in"
          my={24}
        />
      </Form>
      <Link mb={16} onClick={onForgotPassword}>
        Forgot password
      </Link>
      <Typography as="span" textAlign="center" color="grays-mid">
        Jane keeps personal information safe and secure.
      </Typography>
    </Flex>
  );
};
